import React from 'react';
import Select from "react-select";
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import moment from 'moment-timezone';
import ui from 'redux-ui';
import ScrollArea from 'react-scrollbar';
import ReactTable from "react-table";
import "react-table/react-table.css";
import QueryString from 'query-string';

import { AccessHelper, BaseTable } from '../../helpers';
import { Message } from '../Message';
import { PageTitle } from '../PageTitle';
import { RowButton } from '../RowButton';
import { ScrollModule } from '../ScrollModule';
import { TicketsService, GroupingsService } from '../../services';
import i18next from "i18next";


class Tickets extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      localErrorMessage: null,
    };
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
          <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    }

    if (this.props.location.state) {
      return (
          <Message messages={this.props.location} />
      );
    }
    return null;
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  handleHistoryUpdate(params) {
    this.props.history.push(params);
  }

  refresh() {
    this.setState({refresh: true})
  }

  render() {
    return (
        <div className="animated fadeIn">
          <div className="row">
            <PageTitle title={ i18next.t('pages.tickets.header') }
                       refreshFunction={this.refresh.bind(this)} />
          </div>

          {this.renderMessages()}
          <TicketList
            refresh = {this.state.refresh}
            finishedRefresh = {() => {this.setState({refresh: false})}}
            localErrorHandler={this.handleLocalError.bind(this)}
            setClick={click => this.clickChild = click}
            currLocation={this.props.history.location}
            currSearch={this.props.location.search}
            pushHistory={this.handleHistoryUpdate.bind(this)}
          />

        </div>
    );
  }
}

@ui({
  key: 'tickets-list',
  persist: true,
  state: {
    prevPage: null
  }
})
@connect(state => {
  return {
    me: state.user.me,
    currentGrouping: state.currentGrouping.currentGrouping
  }
})
class TicketList extends React.Component {
  constructor(props) {
    super(props);

    const passedState = this.props.currLocation ? this.props.currLocation.state : null;

    this.DEFAULT_SORTED = [];

    this.fetchData = this.fetchData.bind(this);
    this.datafetched = this.datafetched.bind(this);
    this.makeDatatableRequest = this.makeDatatableRequest.bind(this);
    this.updateRequestURL = this.updateRequestURL.bind(this);

    this.state = {
      linkTo: null,
      localErrorHandler: this.props.localErrorHandler,
      hasError: false,
      groupingFilterOptions: passedState ? passedState.groupingFilterOptions : null,
      groupingFilterValue: passedState ? passedState.groupingFilterValue : null,
      data: [],
      pages: null,
      forcePage: null,
      loading: true,
      totalElements: null,
      parsedOptions: QueryString.parse(this.props.currSearch),
      currentHistoryCount: passedState && passedState.currentHistoryCount ? passedState.currentHistoryCount : 0,
      viewAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/monitoring/tickets/view/:ticketId'),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.refresh) {
      this.fetchData(this.refs.ticketsTable && this.refs.ticketsTable.state ? this.refs.ticketsTable.state : null)
    }
  }

  componentDidMount() {
    const parsedOptions = this.state.parsedOptions ? this.state.parsedOptions : {};
    if (this.state.groupingFilterOptions == null) {
      GroupingsService.getAllWithAccess(this.props.currentGrouping.id).then(response => {
        let groupingFilterValue = null;
        if (this.state.groupingFilterValue) {
          groupingFilterValue = this.state.groupingFilterValue;
        } else if (parsedOptions['filterByGroupingId']) {
          let filteredGrouping = response.groupings.filter(group =>
            group.options.some(grouping => grouping.value === parsedOptions['filterByGroupingId'])).map(group => {
            let newGroup = Object.assign({}, group);
            return newGroup.options.filter(grouping => grouping.value === parsedOptions['filterByGroupingId'])
          });
          groupingFilterValue = filteredGrouping[0][0];
        }
        this.setState({
          groupingFilterOptions: response.groupings,
          groupingFilterValue: groupingFilterValue
        });
      }).catch(error => {
        console.error(error);
        this.state.localErrorHandler(error.message);
      });
    }
  }

  updateGroupingFilterValue(newValue) {
    this.setState({
      groupingFilterValue: newValue
    }, () => {
      this.updateRequestURL(this.refs.ticketsTable && this.refs.ticketsTable.state ? this.refs.ticketsTable.state : null);
    });
  }

  viewLinkClick(rowId) {
    this.setState({ linkTo: `/monitoring/tickets/view/${rowId}` });
  }

  datafetched(res) {
    let size = this.refs.ticketsTable.state.pageSize;
    let page = this.refs.ticketsTable.state.page;
    const pageCount = Math.ceil(res.recordsTotal / size)
    let forcePage = null;
    if (page >= pageCount && pageCount > 0) {
      forcePage = pageCount - 1;
    }

    this.setState({
      data: res.data,
      pages: pageCount,
      page: page,
      pageSize: size,
      forcePage: forcePage,
      loading: false,
      totalElements: res.recordsTotal
    });
  }

  fetchData(tableData) {
    if (this.updateRequestURL(tableData)) {
      return;
    }

    this.setState({
      loading: true
    });

    this.makeDatatableRequest(tableData, this.datafetched, null);
  }

  makeDatatableRequest (data, callback) {
    if (this.state.hasError) {
      return;
    }

    let options = BaseTable.buildFetchDataOptions(this.state.parsedOptions, this.DEFAULT_SORTED);

    if (this.state.groupingFilterValue) {
      const ids = this.state.groupingFilterValue.value;
      options.push({ 'filterByGroupingId': ids });
    }

    let isSearch = false;
    if (data.search && data.search.value != null && data.search.value !== '') {
      options.push({ 'search': data.search.value });
      isSearch = true;
    }

    TicketsService.getAll(options, true).then(response => {
      this.props.finishedRefresh()
      callback({
        data: response.tickets,
        recordsTotal: response.page.totalElements,
        recordsFiltered: response.page.totalElements
      });
    }).catch(error => {
      this.props.finishedRefresh()
      console.error(error);
      this.setState({ hasError: true });
      callback({ data: [], recordsTotal: 0, recordsFiltered: 0 });
      this.state.localErrorHandler(error.message);
    });
  }

  renderStatus(alertStatus) {
    return i18next.t(`ticket-statuses.${alertStatus.token}`)
  }

  updateRequestURL(tableData) {
    let options = BaseTable.buildURLOptions(tableData, this.DEFAULT_SORTED);

    if(this.state.groupingFilterValue && this.state.groupingFilterValue.value !== this.state.groupingFilterOptions[0].value) {
      options.push({ 'filterByGroupingId': this.state.groupingFilterValue.value });
    }

    let params = options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');

    const currentSearch = this.props.currSearch ? this.props.currSearch : '?';

    if (`?${params}` !== currentSearch) {
      if (this.state.currentHistoryCount > 100) {
        console.error('Exceeded the history count stack of 100.');
        return false;
      }
      this.props.pushHistory({
        search: `?${params}`,
        state: {
          currentHistoryCount: this.state.currentHistoryCount + 1,
          groupingFilterOptions: this.state.groupingFilterOptions,
          groupingFilterValue: this.state.groupingFilterValue
        }
      });
      return true;
    } else {
      return false;
    }
  }

  render() {
    const { data, pages, loading, totalElements } = this.state;

    if (this.state.linkTo) {
      return <Redirect push to={{ pathname: this.state.linkTo, state: { backLinkSearch: this.props.currSearch }}} />;
    }

    let dynamicOptions = BaseTable.buildDynamicOptions(this.state.parsedOptions, this.state.forcePage, this.DEFAULT_SORTED);

    if (this.state.groupingFilterOptions) {
      return (

        <div className="tickets-content">
        <div className="op-content-box">
          <ScrollModule/>
          <ScrollArea
              speed={0.8}
              className="scroll-container"
              contentClassName="scrollable-content"
              horizontal={true} >

            <div className="row">
              <div className="col-sm-5 pull-right" style={{marginBottom: 10, marginTop: 10, width: 400}}>
                <Select
                    ref="filterByGroupingSelect"
                    options={this.state.groupingFilterOptions}
                    isClearable={true}
                    name="selected-filter-by"
                    value={this.state.groupingFilterValue}
                    onChange={this.updateGroupingFilterValue.bind(this)}
                    isSearchable={true}
                    className="business-filter"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder={i18next.t('select')}
                />
              </div>
            </div>
            <div className="react-table-custom">
              <ReactTable
                className="-striped -highlight"
                ref="ticketsTable"
                manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                data={data}
                pages={pages} // Display the total number of pages
                loading={loading} // Display the loading overlay when we need it
                onFetchData={this.fetchData} // Request new data when things change
                totalElements={totalElements}
                showPaginationTop
                columns={[
                            {
                              Header: i18next.t('table-headers.number'),
                              accessor: "number",
                              sortable: true,
                              minResizeWidth: 50
                            },
                            {
                              Header: i18next.t('table-headers.name'),
                              accessor: "title",
                              sortable: true,
                              minResizeWidth: 50
                            },
                            {
                              Header: i18next.t('table-headers.status'),
                              id: "status",
                              sortable: false,
                              minResizeWidth: 50,
                              accessor: cell => this.renderStatus(cell.status),
                            },
                            {
                              Header: i18next.t('table-headers.last-updated'),
                              accessor: "lastUpdateAt",
                              Cell: cell => <span>{(cell.original.deviceGrouping.timezone ? moment(cell.value).tz(cell.original.deviceGrouping.timezone).fromNow() : moment(cell.value).fromNow())}</span>,
                              sortable: true,
                              minResizeWidth: 50
                            },
                            {
                              Cell: cell => <RowButton 
                                            allowView={this.state.viewAllowed}
                                            viewClick={this.viewLinkClick.bind(this)} 
                                            rowId={cell.original.id}/>,
                              sortable: false,
                              minResizeWidth: 50,
                              width: 90
                            }
                          ]}
                {...dynamicOptions}
              />
            </div>
          </ScrollArea>
        </div>
        </div>

      );
    } else {
      return (
        <div className="loader">{ i18next.t('loading') }</div>
      );
    }
  }
}

export default Tickets;
